import { render, staticRenderFns } from "./Optimize.vue?vue&type=template&id=303c9528&"
import script from "./Optimize.vue?vue&type=script&lang=js&"
export * from "./Optimize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports